<template>
    <Widget :title="$t('components.WebsitesStats.ViewsByPage')" :loading="loading" :report-mode="reportMode">
        <HorizontalBarChart :stats="stats" :styles="styles"/>
    </Widget>
</template>

<script>
/** 
 * WebsitesStats wraps a StackedBarChart and contains the functions to parse
 * and format data from the API.
 * 
 * It represents the number of chats versus the number of referrals grouped
 * by month, day of the week or hour of the day.
 */

import Widget from '@/components/dashboard/Widget';
import HorizontalBarChart from '../charts/HorizontalBarChart.vue';

export default {
    name: 'ViewsByPage',
    data: () => ({ 
        stats: {},
        styles: {
            position: 'relative',
            width: '100%',
            padding: '24px 24px 0',
        },
        groupBy: 'all',
        filterBy: 'month',
        legend: [],
    }),
    props: {
        loading: {
            type: Boolean,
            default: true
        },
        websitesData: {
            type: Object,
            required: true
        },
        reportMode: {
            type: String,
            default: null
        },
        appVersion: {
            type: String,
            default: ''
        }
    },
    computed: {
        isReport() { return this.reportMode !== null },
        colors() {
            return this.$vuetify.theme.isDark ? 
                this.$vuetify.theme.themes.dark : this.$vuetify.theme.themes.light;
        }
    },
    mounted() {
        if (Array.isArray(this.appVersion) && this.appVersion.includes('chatsstats_filtered_month_cumulative')) this.filterBy = 'month_cumulative';
        this.updateStats(this.websitesData);
    },
    watch: {
        websitesData(newData) {
            this.updateStats(newData);
        },
        appVersion(test) {
            if (Array.isArray(test) && test.includes('chatsstats_filtered_month_cumulative')) this.filterBy = 'month_cumulative';
        }
    },
    methods: {
        updateStats(data) {
            if (data) {
                const items = data;
                this.stats = this.formatItems(items);
                this.stats.labels = this.stats.labels.slice(0, 15);
            }
            switch (this.reportMode) {
                case 'daily':
                    this.filterBy = 'hour';
                    break;
                case 'weekly':
                    this.filterBy = 'day';
                    break;
                case 'monthly':
                    this.filterBy = 'month';
                    break;
            }
        },
        formatItems(items) {
            const $t = this.$t.bind(this);
            const labels = [...Object.keys(items)];
            const datasets = [];
            const sessions = {
                label: $t("components.WebsitesStats.UsersByDateLabel"),
                backgroundColor: 'lightblue',
                fill: false,
                tension: 0,
                title: $t("components.WebsitesStats.UsersByDateLabel"),
                data: [],
                xtitle: $t("components.WebsitesStats.ViewsByPageXLabel"),
                ytitle: $t("components.WebsitesStats.ViewsByPageYLabel")
            }
            const { length } = labels;
            for (let i = 0; i < length; i++) {
                const item = items[labels[i]];
                sessions.data.push(item);
            }
            datasets.push(sessions)
            return { labels, datasets };
        }
    },
    components: { Widget, HorizontalBarChart }
}
</script>

<style>
    .circle {
        display: inline-block;
        vertical-align: top;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin: 4px 12px;
    }

    .label {font-size:  1.2em !important;}
    .input-label.input-label {font-size:  1.02em !important;}
    
    .groupby .v-text-field__details { display: none; }
</style>